<div mat-dialog-content style="padding: 10px 30px;">

    <div class="us-invite-title">Invite a Real Estate Agent</div>
    <br>
    <div class="us-invite-subtitle">Enter the name and email of the partner real estate agent you'd like to invite to
        join
        HomeDashboard. They will
        receive
        an email with a link to register for a HomeDashboard account that will be co-branded with your profile.</div>
    <div class="Vert-30"></div>
    <form [formGroup]="userInfoForm">
        <div class="row">
            <mat-form-field class="col-12" appearance="outline" floatLabel="always">
                <mat-label>First</mat-label>
                <input type="text" matInput formControlName="firstName" placeholder="First Name" required>
                <mat-error *ngIf="userInfoForm.controls.firstName.errors?.required">First
                    name
                    is required</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col-12" appearance="outline" floatLabel="always">
                <mat-label>Last</mat-label>
                <input type="text" matInput formControlName="lastName" placeholder="Last Name" required>
                <mat-error *ngIf="userInfoForm.controls.lastName.errors?.required">Last name
                    is
                    required</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col-12" appearance="outline" floatLabel="always">
                <mat-label>Email</mat-label>
                <input type="text" matInput formControlName="email" placeholder="Email" required>
                <mat-error *ngIf="userInfoForm.controls.email.errors?.required">Email
                    is required</mat-error>
                <mat-error *ngIf="!userInfoForm.controls.email.errors?.required && userInfoForm.controls.email.invalid">
                    Email
                    format is incorrect</mat-error>
            </mat-form-field>
        </div>
    </form>
</div>

<mat-dialog-actions class="dialog-actions" align="end" style="margin-bottom: -10px;    padding: 8px 10px;">
    <button mat-stroked-button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
    <button mat-stroked-button [disabled]="!userInfoForm.valid" class="btn btn-primary" (click)="onSend()"
        cdkFocusInitial>
        Send Email
    </button>
</mat-dialog-actions>